import * as React from 'react';
import AmCharts from "@amcharts/amcharts3-react";
import { _ } from "@src/services/i18n";
import { classNames, css, mixin, vars, defaultProps, formatters } from '@src/services/theme';
import { Proto, Props, State } from '@src/components/Proto';
import { Box, GaugeCustom } from '@src/components';

// typing

// style
const style = css`
  ${mixin.row} > * {
  }

  .info {
    .table {
      > thead {
        > tr {
          > th {
            font-weight: 500;
            background: #eeeeee;
            border-bottom: 1px solid #ccc;
            margin-bottom: 5px;
          }
        }
      }
      > tbody {
        > tr {
          > td {
            vertical-align: middle;
            &.icn {
              text-align: center;
              > img {
                width: 70px;
              }
            }
          }
        }
      }
    }
  }
  .stats {
    > article {
      ${mixin.row2}
      margin: 0;
      padding: 20px;
      background: ${vars.colors.greyLight};
      border: 1px solid ${vars.colors.grey};
      > figure {
      }
      > div {
        width: 250px !important;
        > h4 {
          font-weight: 500;
          font-size: 30px;
          text-transform: uppercase;
        }
        > p {
          font-size: 14px;
        }
      }
      &:not(:last-child) {
        margin-bottom: 10px;
      }
    }
  }
`;

// component
export class Stats extends Proto<Props, State> {

	// render
	render() {
        const loading = this.loading();
        if (loading) return loading;
        const { data } = this.state;
        const stats = data.data;
        
		return (
            <div className={style}>
                <section className="info">
                    <table className="table">
                    <thead>
                        <tr>
                            <th></th>
                            <th>{_('stats_parameter', 'BatteryCycle')}</th>
                            <th>{_('stats_value', 'BatteryCycle')}</th>
                            <th>{_('stats_unit', 'BatteryCycle')}</th>
                        </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td rowSpan={2} className="icn"><img src="/files/icons2/gauge_medium.svg" /></td>
                        <td>{_('stats_startvoltage', 'BatteryCycle')}</td>
                        <td>{stats.startvoltage}</td>
                        <td>V</td>
                    </tr>
                    <tr>
                        <td>{_('stats_endvoltage', 'BatteryCycle')}</td>
                        <td>{stats.endvoltage}</td>
                        <td>V</td>
                    </tr>
                    <tr>
                        <td rowSpan={1} className="icn"><img src="/files/icons2/power.svg" /></td>
                        <td>{_('stats_startcurrent', 'BatteryCycle')}</td>
                        <td>{stats.startcurrent}</td>
                        <td>A</td>
                    </tr>
                    {/*
                    <tr>
                        <td>Ending current</td>
                        <td>{"TODO"}</td>
                        <td>A</td>
                    </tr>
                    */}
                    <tr>
                        <td rowSpan={3} className="icn"><img src="/files/icons2/battery.svg" /></td>
                        <td>{_('stats_startsoc', 'BatteryCycle')}</td>
                        <td>{stats.startsoc}</td>
                        <td>%</td>
                    </tr>
                    <tr>
                        <td>{_('stats_endsoc', 'BatteryCycle')}</td>
                        <td>{stats.endsoc}</td>
                        <td>%</td>
                    </tr>
                    <tr>
                        <td>{_('stats_minsoc', 'BatteryCycle')}</td>
                        <td>{stats.minsoc}</td>
                        <td>%</td>
                    </tr>
                    <tr>
                        <td rowSpan={2} className="icn"><img src="/files/icons2/clock.svg" /></td>
                        <td>{_('stats_bulkcharge', 'BatteryCycle')}</td>
                        <td>{stats.bulkcharge}</td>
                        <td>h</td>
                    </tr>
                    <tr>
                        <td>{_('stats_absorptioncharge', 'BatteryCycle')}</td>
                        <td>{stats.absorptioncharge}</td>
                        <td>h</td>
                    </tr>
                    {/*
                    <tr>
                        <td>Equalization cycles</td>
                        <td>{"TODO"}</td>
                        <td>n</td>
                    </tr>
                    */}
                    <tr>
                        <td rowSpan={2} className="icn"><img src="/files/icons2/charge.svg" /></td>
                        <td>{_('stats_chargedah', 'BatteryCycle')}</td>
                        <td>{stats.chargedah}</td>
                        <td>A/h</td>
                    </tr>
                    <tr>
                        <td>{_('stats_dischargedah', 'BatteryCycle')}</td>
                        <td>{stats.dischargedah}</td>
                        <td>A/h</td>
                    </tr>
                    <tr>
                        <td rowSpan={2} className="icn"><img src="/files/icons2/temp.svg" /></td>
                        <td>{_('stats_starttemp', 'BatteryCycle')}</td>
                        <td>{stats.starttemp}</td>
                        <td>°C</td>
                    </tr>
                    <tr>
                        <td>{_('stats_endtemp', 'BatteryCycle')}</td>
                        <td>{stats.endtemp}</td>
                        <td>°C</td>
                    </tr>
                    <tr>
                        <td rowSpan={1} className="icn"><img src="/files/icons2/clock_start.svg" /></td>
                        <td>{_('lastcycles_cycle_devtime', 'BatteryCycle')}</td>
                        <td colSpan={2}><span>{stats.cycle_devtime != null ? formatters.datetime(stats.cycle_devtime) : "-"}</span></td>
                    </tr>
                    <tr>
                        <td rowSpan={1} className="icn"><img src="/files/icons2/clock_stop.svg" /></td>
                        <td>{_('lastcycles_cycle_endtime', 'BatteryCycle')}</td>
                        <td colSpan={2}><span>{stats.cycle_endtime != null ? formatters.datetime(stats.cycle_endtime) : "-"}</span></td>
                    </tr>

                    </tbody></table>
                </section>
                <section className="stats">
                    <article>
                        <div>
                            <h4>{_('stats_balancing', 'BatteryCycle')} ({stats.maxdeltav}V)</h4>
                            <p>{_('stats_balancing_notes', 'BatteryCycle')}</p>
                        </div>
                        <figure>
                            <GaugeCustom bg="balancing" {...stats.maxdeltav_2} />
                        </figure>
                    </article>
                    {stats.soh &&
                    <article>
                        <div>
                            <h4>{_('stats_soh', 'BatteryCycle')} ({stats.soh}%)</h4>
                        </div>
                        <figure>
                            <GaugeCustom bg="soh" {...stats.soh_2} />
                        </figure>
                    </article>
                    }
                </section>
            </div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/BatteryCycle/Stats.tsx